import { BrowserModule } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from './services/interceptor/interceptor.service';
import { AppComponent } from './app.component';
import { LayoutsModule } from './layouts/layouts.module'
import { PagesModule } from './pages/pages.module';
import { SharedModule } from './shared/shared.module';
import { AuthGuard, FreezGuard, GSGuard } from './auth.guard';
import { DatePipe } from '@angular/common';
// import { IntercomModule } from 'ng-intercom';
import { CustomErrorHandlerService } from './services/shared/custom-error-handler.service';
// import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { environment } from 'src/environments/environment';
import { BsDatepickerConfig, BsDatepickerInlineConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { PrepaidCardModalComponent } from './shared/prepaid-card-modal/prepaid-card-modal.component';
// const config: SocketIoConfig = {
//   url: `${environment.socketurl}`,
//   options: {
//     reconnection: true,
//     reconnectionAttempts: 13,
//     reconnectionDelay: 3000,
//     reconnectionDelayMax: 5000,
//     transports: ['websocket', 'polling', 'flashsocket'],
//     path: environment.socket_name_space
//   }
// }
export function playerFactory() {
  return player;
}
@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        LayoutsModule,
        PagesModule,
        // IntercomModule,
        // SocketIoModule.forRoot(config),
        SharedModule.forRoot(),
        BsDatepickerModule.forRoot(),
        LottieModule.forRoot({ player: playerFactory }),
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.serviceWorker,
            registrationStrategy: 'registerWhenStable:30000'
        }),
        PrepaidCardModalComponent
    ],
    providers: [
        DatePipe,
        AuthGuard,
        BsDatepickerConfig,
        BsDatepickerInlineConfig,
        GSGuard,
        FreezGuard,
        { provide: ErrorHandler, useClass: CustomErrorHandlerService },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
